module.exports = (window.Handlebars["default"] || window.Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class='glyphicon glyphicon-earphone'></span> "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.phoneNumber : depth0), depth0))
    + "&nbsp;<button class='close'>&times;</button>";
},"useData":true})